module.exports = __webpack_public_path__ + "static/media/Queen Bohemian Rhapsody (Official Video Remastered).9ca687f0.mp3";